<template>
  <div>
    <option-until-action></option-until-action>
    <option-times-until-action></option-times-until-action>
    <option-interval-until-action></option-interval-until-action>
  </div>
</template>

<script>
import OptionUntilAction from './UntilAction.vue';
import OptionTimesUntilAction from './TimesUntilAction.vue';
import OptionIntervalUntilAction from './IntervalUntilAction.vue';

export default {
  components: {
    OptionUntilAction,
    OptionTimesUntilAction,
    OptionIntervalUntilAction,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?1a5e7e42
 **/